import { InjectionToken } from '@angular/core';

/**
 * The route a shell served away from its own /ng/ URL asks the app to draw — see SstController. Read once
 * where the router is configured, so the router option and the component that navigates cannot disagree.
 */
export const INITIAL_ROUTE = new InjectionToken<string>('initial route');
